import { useTracking } from "@edreamsodigeo/frontend-core";
const useTrackingBookingAuth = () => {
  const {
    trackEvent
  } = useTracking();
  const trackEventBookingAuth = (label, isError) => {
    trackEvent({
      category: "sso_sign_in_trips",
      action: `find_booking${isError ? "_error" : ""}`,
      label
    });
  };
  return {
    trackEventBookingAuth
  };
};
export default useTrackingBookingAuth;